import { CalendarPlus, Download, Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useCourtyard } from "@/context/CourtyardContext";
import { googleCalLink, icsLink } from "@/lib/event";

export default function CalendarMenu({ className = "btn-ghost whitespace-nowrap px-4" }) {
  const { event: ev } = useCourtyard();
  const ready = ev.calendar_ready;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className={className} aria-disabled={!ready || undefined} data-testid="add-to-calendar-button">
          <CalendarPlus className="h-4 w-4" aria-hidden="true" /> Add to calendar
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(92vw,320px)] rounded-2xl border-[rgba(181,148,82,.5)] bg-[var(--ivory)] p-4 text-[var(--ink)]" data-testid="calendar-popover">
        {ready ? (
          <div className="flex flex-col gap-2">
            <p className="font-display text-xl font-semibold text-[var(--emerald)]">Calendar mein daalo</p>
            <a href={googleCalLink(ev)} target="_blank" rel="noopener noreferrer" className="btn-ghost justify-start" data-testid="google-calendar-link">
              <CalendarPlus className="h-4 w-4" aria-hidden="true" /> Google Calendar
            </a>
            <a href={icsLink(ev)} className="btn-ghost justify-start" data-testid="ics-download-link">
              <Download className="h-4 w-4" aria-hidden="true" /> Apple / Outlook (.ics)
            </a>
            <p className="text-xs" data-testid="calendar-timezone-note">Times are set in {(ev.timezone || "").replace("_", " ")}. Your calendar converts automatically.</p>
          </div>
        ) : (
          <div className="flex gap-3" data-testid="calendar-unavailable">
            <Info className="mt-0.5 h-5 w-5 shrink-0 text-[var(--brass-deep)]" aria-hidden="true" />
            <p className="text-sm leading-relaxed">
              Calendar invites open once the host confirms an end time. Check back soon!
            </p>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
